import Confirm from 'apps/auth/components/cards/confirm/Confirm';
import ConfirmPreview from 'apps/auth/components/cards/confirm/ConfirmPreview';
import MyCards from 'apps/auth/components/cards/MyCards';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';

const authCard = [
    {
        path: '/auth/mycards',
        component: MyCards,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isChatBottomUp: true,
            initCard: true,
        },
    },
    {
        path: '/auth/card/confirm/:cardId/preview',
        component: ConfirmPreview,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
        },
    },
    {
        path: '/auth/card/confirm/:cardId',
        component: Confirm,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
        },
    },
];

export default authCard;
